<script setup lang="ts">
import { ButtonSizeEnum, ButtonStyleEnum } from '~/types';

withDefaults(defineProps<{
  type?: 'button' | 'submit';
  styleType?: keyof typeof ButtonStyleEnum;
  size?: keyof typeof ButtonSizeEnum;
}>(), {
  type: 'button',
  styleType: ButtonStyleEnum.purple,
  size: ButtonSizeEnum.md,
});

const styles: Record<keyof typeof ButtonStyleEnum, string> = {
  'purple': 'bg-viola-600 text-light-gray font-semibold border-transparent',
  'orange': 'bg-peach-500 text-white font-medium border-transparent',
  'outline': 'bg-transparent text-white font-medium border-white',
  'gray': 'bg-white/70 text-viola-400 font-bold border-transparent',
  'peach': 'bg-peach-300 text-viola-600 font-semibold border-transparent',
  'light-peach': 'bg-fox-200 text-light-gray font-semibold border-transparent',
};

const sizes: Record<keyof typeof ButtonSizeEnum, string> = {
  sm: 'text-[0.875rem] py-2 px-[1.125rem] fhd:text-md 4k:text-[1.15rem]',
  md: 'text-subheading-3xs py-[0.875rem] px-7.5 4k:text-subheading-2xs',
  lg: 'text-subheading-2xs 2xs:text-subheading-xs py-[1.425rem] px-[3.35rem] 4k:text-subheading',
};
</script>

<template>
  <button
    :type
    :class="[styles[styleType], sizes[size], 'uppercase relative overflow-hidden cursor-pointer rounded-full transition duration-500 border-2 after:absolute after:-inset-[50%] after:bg-gradient-to-b after:from-transparent after:via-white/50 after:to-transparent after:rotate-60 hover:after:animate-shine']"
  >
    <p class="relative z-10 leading-none">
      <slot />
    </p>
  </button>
</template>

<style scoped lang="scss">
button {
  &:after {
    transform: rotateZ(60deg) translate(-100%, 7.5em);
  }
}
</style>
